var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "box view-nav-bar" },
      [
        _c("b-form-select", {
          staticClass: "transparent-input shx-th-120",
          attrs: { options: _vm.saleshouseOptions },
          on: { change: _vm.onSaleshouseChange },
          model: {
            value: _vm.saleshouse,
            callback: function ($$v) {
              _vm.saleshouse = $$v
            },
            expression: "saleshouse",
          },
        }),
        _vm._v(" "),
        _c("b-form-input", {
          staticClass: "transparent-input",
          attrs: { type: "text", placeholder: "From (e.g. 2026C01)" },
          model: {
            value: _vm.from,
            callback: function ($$v) {
              _vm.from = $$v
            },
            expression: "from",
          },
        }),
        _vm._v(" "),
        _c("b-form-input", {
          staticClass: "transparent-input",
          attrs: { type: "text", placeholder: "To (e.g. 2026C52)" },
          model: {
            value: _vm.to,
            callback: function ($$v) {
              _vm.to = $$v
            },
            expression: "to",
          },
        }),
        _vm._v(" "),
        _vm.totalRows !== null
          ? _c("b-pagination", {
              attrs: {
                "total-rows": _vm.totalRows,
                "per-page": _vm.perPage,
                "aria-controls": "adm-week-table",
              },
              model: {
                value: _vm.currentPage,
                callback: function ($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { class: "box-content pt-3" + (_vm.totalRows ? "" : " d-none") },
        [
          _c("b-table", {
            ref: "dataTable",
            staticClass: "shx-table w-100",
            attrs: {
              id: "adm-week-table",
              hover: "",
              dark: "",
              fixed: "",
              "sort-icon-left": "",
              busy: _vm.fetching,
              fields: _vm.columns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              currentPage: _vm.currentPage,
              perPage: 0,
              items: _vm.fetchData,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(admissions)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatInt(data.item.admissions))),
                    ]),
                  ]
                },
              },
              {
                key: "cell(real_weighted)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          data.item.real_weighted !== null
                            ? data.item.real_weighted + "%"
                            : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    data.item.real_weighted !== null &&
                    data.item.real_weighted <= 90
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-warning ml-1",
                            attrs: {
                              title:
                                "Minimum real: " + data.item.real_min + "%",
                            },
                          },
                          [_vm._v("⚠")]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link",
                        on: { click: data.toggleDetails },
                      },
                      [
                        _c("icon", {
                          attrs: {
                            name:
                              "chevron-" +
                              (data.detailsShowing ? "up" : "down"),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "row-details",
                fn: function (data) {
                  return [
                    _c("admissions-cinemas-table", {
                      attrs: {
                        bucket: "week",
                        "parent-key": data.item.week_code,
                        saleshouse: _vm.saleshouse,
                      },
                    }),
                  ]
                },
              },
              {
                key: "table-busy",
                fn: function () {
                  return [_c("table-spinner")]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.totalRows
        ? _c(
            "div",
            { staticClass: "box-content pt-4 text-center text-muted" },
            [_vm._v("No admissions yet.")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _vm.totalRows !== null
          ? _c("b-pagination", {
              attrs: {
                "total-rows": _vm.totalRows,
                "per-page": _vm.perPage,
                "aria-controls": "adm-week-table",
              },
              model: {
                value: _vm.currentPage,
                callback: function ($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }